import React from 'react';
import styled from 'styled-components';
import {MainBg} from '../styled-components/styles';
import {connect} from 'react-redux'

function CartIcon (props) {
    return (
      <CartWrap className={`cart-icon relative flex justify-center align-center circle ${props.cart ? "active": null}`}>
        {props.cart ? <CartNum className="absolute flex justify-center align-center circle">{props.cart.length}</CartNum> : null}
        <i className="iconfont">&#xe616;</i>
      </CartWrap>
    )
}

const CartWrap = styled(MainBg)`
  width: 60px;
  height: 60px;
  cursor: pointer;

  color: #fff;
  i {
    font-size: 1.8em;
  }
  box-shadow: 2px 2px 5px 0 rgba(100, 100, 100, 0.5);

  @media screen and (max-width: 500px){
    transform: scale(.8);
  }
`

const CartNum = styled.div`
  right: 0;
  top: -15px;
  font-size: 1.2em;
  width: 30px;
  height: 30px;
  background: #fff;
  color: #A63730;
  border: 1px solid #A63730;
`

export default CartIcon;